import React from 'react';

const DeliverySvg = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            className="svgDeliveryWrap"
            {...props}
            width="24"
            height="24"
            viewBox="0 0 65.5 43.62"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M47.74 1v27.29a7.53 7.53 0 00-3.94 5H22.05a7.57 7.57 0 00-14.72 0H1V9.44A8.44 8.44 0 019.44 1z"></path>
            <path d="M46.74 1v27.29l.5-.87A8.77 8.77 0 0042.83 33l1-.74H22.05L23 33a8.68 8.68 0 00-8.33-6.54A8.66 8.66 0 006.36 33l1-.74H1l1 1v-22c0-2.49.15-4.85 2-6.82C7 1.16 12.09 2 16.09 2h31.65a1 1 0 000-2h-37a11.58 11.58 0 00-6 1.23A9.7 9.7 0 000 9.78v23.49a1 1 0 001 1h6.33a1 1 0 001-.73 6.57 6.57 0 0112.79 0 1 1 0 001 .73H43.8a1 1 0 001-.73 6.77 6.77 0 013.49-4.39 1 1 0 00.49-.86V1a1 1 0 00-2.04 0z"></path>
            <path d="M21.27 35.05A6.57 6.57 0 019.9 39.56a6.59 6.59 0 015.8-11 6.68 6.68 0 015.57 6.51 1 1 0 002 0 8.74 8.74 0 00-6-8.19 8.58 8.58 0 106 8.19 1 1 0 00-2-.02z"></path>
            <path d="M63.5 21.89v11.38l1-1h-6l1 .74a8.64 8.64 0 00-12.1-5.66l1.5.87v-15l-1 1h8.85l-.75-.31c2.58 2.89 5.27 5.71 7.75 8.69.83 1 2.24-.43 1.42-1.41-1.92-2.3-4-4.49-6-6.72-.61-.68-1.48-2.16-2.48-2.27a37.75 37.75 0 00-4.12 0H47.9a1 1 0 00-1 1v15a1 1 0 001.51.86 6.61 6.61 0 019.14 4.46 1 1 0 001 .73h6a1 1 0 001-1V21.89a1 1 0 00-2.05 0z"></path>
            <path d="M47.9 24.24h15.81a1 1 0 000-2H47.9a1 1 0 000 2z"></path>
            <path d="M57.74 35.05a6.57 6.57 0 01-11.09 4.79 6.58 6.58 0 1111.09-4.79 1 1 0 002 0 8.57 8.57 0 00-15.63-4.88 8.58 8.58 0 1015.63 4.88 1 1 0 00-2 0z"></path>
            <path
                d="M64.5 22.15v11.38h-5.92l-.06-.25a7.62 7.62 0 00-10.62-4.92.33.33 0 00-.16.07 7.37 7.37 0 00-3.94 4.85l-.06.25H43V22.15z"
                fill="#221f20"
                stroke="#221f20"
                strokeMiterlimit="10"
                strokeWidth=".4px"
            ></path>
        </svg>
    );
};

export default DeliverySvg;
